import { render, staticRenderFns } from "./EmptyLayout.vue?vue&type=template&id=ff4c997c&scoped=true&"
import script from "./EmptyLayout.vue?vue&type=script&lang=js&"
export * from "./EmptyLayout.vue?vue&type=script&lang=js&"
import style0 from "./EmptyLayout.vue?vue&type=style&index=0&id=ff4c997c&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ff4c997c",
  null
  
)

export default component.exports